<div class="header__container">
  @if (data()?.ribbon_text?.length && isAffiliateProgram() && data()?.isAffiliatePackage) {
  @for (item of data()?.ribbon_text; track $index) {
  <div class="flagging">{{item}}</div>
  }
  }
  <button type="button" class="close__btn" (click)="onClickClose()" (keydown)="onClickClose()" tabindex="0">
    <img src="assets/icons/close.svg" alt="close-icon">
  </button>
  @if (data()?.end_time && isAffiliateProgram() && data()?.isAffiliatePackage) {
    <div class="period">{{'package.endsAt' | translate}} {{data()?.end_time}} WIB</div>
  }
  @if (data()?.name) {
  <div [ngClass]="isAffiliateProgram() ? 'text-f-16 mb-2' : 'text-lg'" class="name">{{data()?.name}}</div>
  }
  <div class="wrap__price">
    @if(isPoinPackage()) {
    <ng-container *ngTemplateOutlet="poin; context: contextDataPoin()"></ng-container>
    }@else {
    <ng-container *ngTemplateOutlet="promo ; context: contextDataPromo()"></ng-container>
    }
  </div>
  <div class="original__price-wrap">
    @if (data()?.originalprice && data()?.originalprice !== 0) {
    <span class="price">{{data()?.originalprice ?? 0 | currency}}</span>
    }
    @if (data()?.discountPercentage && data()?.discountPercentage !== 0) {`
    <span class="discount">{{data()?.discountPercentage ?? 0 | percentage}}</span>
    }
  </div>
  @if (isAffiliateProgram() && isAffiliateProgram() && data()?.isAffiliatePackage) {
  <div class="progress__wrap">
    <div [style]="{'width': data()?.purchasePercentage ? data()?.purchasePercentage+'%' : '0%'}" class="progress">
    </div>
    <span>{{data()?.purchasePercentage ?? 0 | percentage}} {{'promo.sold' | translate}}</span>
  </div>
  }
</div>

<ng-template #promo let-price="price" let-validity="validity">
  <div class="price">{{price | currency}}</div>
  @if (!isAffiliateProgram() && validity) {
  <div class="validity">{{validity }}-days validity</div>
  }
</ng-template>

<ng-template #poin let-poin="poin">
  <div class="poin">{{poin}}<span>poin</span></div>
</ng-template>
